$(document).on('click', '.catalog-order__show', function(e) {
    let parent = $(this).parents(".catalog-order")
    if($(parent).hasClass("_active")){
        $(this).parents(".catalog-card").find(".catalog-order").removeClass("_active")
        $(this).parents(".catalog-card").find(".catalog-order__hidden").slideUp()
    } else{
        $(this).parents(".catalog-card").find(".catalog-order").removeClass("_active")
        $(this).parents(".catalog-card").find(".catalog-order__hidden").slideUp()
        $(parent).addClass("_active")
        $(this).siblings(".catalog-order__hidden").slideDown()
    }
})

$(".filter-group__item-btn").click(function () {
    let parent = $(this).parents(".filter-group__item")
    $(parent).toggleClass("_active")
    $(parent).find(".filter-group__item-hidden").slideToggle()
})

$(document).on('click', '.filter-group__show', function(e) {
    let parent = $(this).parents(".filter-group")
    $(parent).toggleClass("_active")
    $(parent).find(".filter-group__hidden").slideToggle()
})

$(".filter-btn").click(function () {
    $(".catalog-sidebar").addClass("_active")
    $("body").addClass("fixed-body")
})


$(document).on('click', '.catalog-sidebar__close', function(e) {
    $(".catalog-sidebar").removeClass("_active")
    $("body").removeClass("fixed-body")
    $(".products-modal").removeClass("_opened-filter")
})


$(document).on('click', '.catalog-group__color', function(e) {
    let tabId = $(this).attr("data-tab")
    let parent = $(this).parents(".product-table,.shoe-table")

    $(parent).find(".catalog-group__color").removeClass("_active")
    $(this).addClass("_active")

    $(parent).find(".product-table__groups").removeClass("_active")
    $(parent).find(`.product-table__groups[data-tab="${tabId}"]`).addClass("_active")
})

